import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Container, Grid, TextField, MenuItem } from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import { mensagemErro, nomePerfil } from "../../services/acesso";
import LinkGerado from "../../components/LinkGerado";
import { StyledTableCell, StyledTableRow, useStyles } from "../users/ListingUser/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { LinearProgress } from "@material-ui/core";
import moment from "moment";

const STATUS = {
    pendente: "Pendente",
    usado: "Usado",
    expirado: "Expirado",
    revogado: "Revogado",
};

const Convites = () => {
    const classes = useStyles();
    const history = useHistory();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [email, setEmail] = useState("");
    const [perfil, setPerfil] = useState("assessor");
    const [dias, setDias] = useState(7);
    const [perfis, setPerfis] = useState([]);
    const [gerado, setGerado] = useState(null);
    const [salvando, setSalvando] = useState(false);

    const carregar = async () => {
        setLoading(true);
        try {
            const result = await api.get("convites");
            const data = result.data?.data || result.data || [];
            setRows(Array.isArray(data) ? data : []);
        } catch (e) {
            toast.error(mensagemErro(e, "Não foi possível carregar os convites"));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        carregar();
        api.get("acoes").then((result) => {
            setPerfis(result.data?.perfis || []);
        }).catch(() => {});
    }, []);

    const gerar = async () => {
        if (!email) {
            toast.error("Informe o e-mail");
            return;
        }
        const diasNumero = Number(dias);
        if (!diasNumero || diasNumero < 1 || diasNumero > 30) {
            toast.error("A validade deve ficar entre 1 e 30 dias");
            return;
        }
        setSalvando(true);
        setGerado(null);
        try {
            const result = await api.post("convites", {
                email,
                perfil,
                dias: diasNumero,
            });
            setGerado({
                link: result.data.link,
                email: result.data.email || email,
                email_status: result.data.email_status,
            });
            toast.success("Convite gerado");
            setEmail("");
            carregar();
        } catch (e) {
            toast.error(mensagemErro(e, "Não foi possível gerar o convite"));
        } finally {
            setSalvando(false);
        }
    };

    const revogar = async (id) => {
        try {
            await api.delete(`convites/${id}`);
            toast.success("Convite revogado");
            carregar();
        } catch (e) {
            toast.error(mensagemErro(e, "Não foi possível revogar o convite"));
        }
    };

    return (
        <Container fixed>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h1>Convites</h1>
                <Button variant="outlined" onClick={() => history.push("/users")}>Voltar</Button>
            </div>
            <div style={{ backgroundColor: "#fff", padding: 16, border: "1px solid rgba(0,0,0,0.12)", borderRadius: 5 }}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <TextField label="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField select label="Perfil" value={perfil} onChange={(e) => setPerfil(e.target.value)} fullWidth>
                            {(perfis.length ? perfis : [
                                { id: "assessor", nome: "Assessor" },
                                { id: "gestor", nome: "Gestor" },
                                { id: "auditor", nome: "Auditor" },
                                { id: "confirmacao", nome: "Confirmação" },
                                { id: "master", nome: "Master" },
                            ]).map((item) => (
                                <MenuItem key={item.id} value={item.id}>{item.nome || nomePerfil(item.id)}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField label="Validade (dias)" type="number" value={dias} onChange={(e) => setDias(e.target.value)} inputProps={{ min: 1, max: 30 }} fullWidth />
                    </Grid>
                    <Grid item xs={3} style={{ display: "flex", alignItems: "flex-end" }}>
                        <Button variant="contained" style={{ color: "#4B8B33" }} disabled={salvando} onClick={gerar}>
                            Gerar convite
                        </Button>
                    </Grid>
                </Grid>
                <LinkGerado link={gerado?.link} email={gerado?.email} emailStatus={gerado?.email_status} />
            </div>
            <br />
            <TableContainer component={Paper}>
                {loading && <LinearProgress />}
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="center">E-mail</StyledTableCell>
                            <StyledTableCell align="center">Perfil</StyledTableCell>
                            <StyledTableCell align="center">Expira em</StyledTableCell>
                            <StyledTableCell align="center">Status</StyledTableCell>
                            <StyledTableCell align="center">Ações</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <StyledTableRow key={row.id}>
                                <StyledTableCell align="center">{row.email}</StyledTableCell>
                                <StyledTableCell align="center">{row.perfil_nome || nomePerfil(row.perfil)}</StyledTableCell>
                                <StyledTableCell align="center">
                                    {row.expira_em ? moment(row.expira_em).format("DD/MM/YYYY HH:mm") : ""}
                                </StyledTableCell>
                                <StyledTableCell align="center">{STATUS[row.status] || row.status}</StyledTableCell>
                                <StyledTableCell align="center">
                                    {row.status === "pendente" && (
                                        <Button size="small" onClick={() => revogar(row.id)}>Revogar</Button>
                                    )}
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    );
};

export default Convites;
